export const WORK_ACTIVITY_STATUS = {
    BSW: 296,
    PED100: 411,
    TEMP_IN_ENCAP: 412,
};

export const WORK_ACTIVITY_STATUSES_COPPER_DECOM = [
    process.env.REACT_APP_WORK_ACTIVITY_EXTRACTION_BURIED,
    process.env.REACT_APP_WORK_ACTIVITY_EXTRACTION_AERIAL,
];
